import { render } from "./ZNtrustee.vue?vue&type=template&id=1e20073c&scoped=true"
import script from "./ZNtrustee.vue?vue&type=script&lang=js"
export * from "./ZNtrustee.vue?vue&type=script&lang=js"

import "./ZNtrustee.vue?vue&type=style&index=0&id=1e20073c&lang=scss&scoped=true"
import "./ZNtrustee.vue?vue&type=style&index=1&id=1e20073c&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e20073c"]])

export default __exports__